import { Stack } from "@mui/material";
import { Chip, ChipProps } from "@surya-digital/leo-reactjs-material-ui";
import React from "react";

export const RightAlignedChip: React.FC<ChipProps> = (props) => {
  return (
    <Stack width="min-content">
      <Chip {...props} />
    </Stack>
  );
};
